import { jsx } from "react/jsx-runtime";
function renderShellLink(renderLink, props, target) {
  return renderLink ? renderLink(props, target) : /* @__PURE__ */ jsx("a", { ...props });
}
export {
  renderShellLink
};
//# sourceMappingURL=links.js.map
